import React, { useState, useEffect } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { sessionSetItemObj, sessionGetItemJSON } from '../../utils/sessionHelpers'
import { startLoading, doneLoading } from '../../utils/loading'
import { sessionGetItemObj } from '../../utils/sessionHelpers'
import { downloadCheckFile, getExpensesCheckList } from '../../redux/actions/accountingExpenses'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { downloadFile } from '../../utils/fileUtil'
import SearchForNamesTable from './SearchForNamesTable'
import TablePagination from 'rsuite/lib/Table/TablePagination'

export default function SearchForNamesWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  console.log('formSchema==>', formSchema)
  const history = useHistory()

  const projectCode = sessionStorage.getItem('projectCode')
  const { periodNumber } = sessionGetItemObj('periodInfo')
  const periodInfo = sessionGetItemJSON('periodInfo')

  // const handleSearch = async (request) => {
  //   setIsLoading(true)
  //   startLoading()

  //   try {
  //     const response = await getExpensesCheckList(request, projectCode, periodNumber)
  //     // console.log('resssss 99999 ', response)
  //     setFormSchema(response)
  //   } catch (error) {
  //     console.log('error ', error)
  //   }

  //   doneLoading()
  //   setIsLoading(false)
  // }

  return (
    <>
      <Panel shaded collapsible defaultExpanded bordered>
        <SearchForNamesTable
          schema={formSchema}
          Controller={Controller}
          control={control}
          pagination={true}
          loading={isLoading}
          // onSearch={(req) => {
          //   handleSearch(req)
          // }}
          // onCancel={(req) => {
          //   handleSearch({})
          // }}
        />

        {isLoading && <OverlayLoader />}
      </Panel>
    </>
  )
}
